import Nullstack from 'nullstack';
export default function IconBrandAlgolia({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-algolia",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "4",
    y: "4",
    width: "16",
    height: "16",
    rx: "2"
  }), "   ", Nullstack.element("path", {
    d: "M11.5 7h1"
  }), "   ", Nullstack.element("path", {
    d: "M7.403 9.11l.707 -.706"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "13",
    r: "3.5"
  }), "   ", Nullstack.element("path", {
    d: "M12 12v1l.9 -.5z"
  }), " ");
}